import React from "react";
import { XCircle } from "../../../../../../node_modules/react-feather/dist/index";
import { ResultsSelect } from "../../../../../Components/Map/Form/Select";
import { ResultsLayerInfo } from "../../../../../Components/Map/Form/Select";
import { NumericResultsInput } from "../../../../../Components/Map/Form/NumericInput";
import { downloadBlobAsync } from "../../../../../api/storageApi";
import { isolinesPreset } from "../../../ResultsConst";
import {
  changeIsolinesPage,
  changeIsolinesLayer,
  changeIsolinesPreset,
  changeIsolinesMin,
  changeIsolinesMax,
  changeIsolinesBreakNumber,
  changeIsolinesBreakInterval,
  loadIsolinesSelectedCaseData,
  changeNewLayerIsolinesCase,
} from "../../../../../redux/actions/resultsActions";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

class Isolines extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tempValue: null,
    };
    this.onCaseChange = this.onCaseChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onLayerChange = this.onLayerChange.bind(this);
    this.onIsolinesPresetChange = this.onIsolinesPresetChange.bind(this);
    this.onIsolinesMinChange = this.onIsolinesMinChange.bind(this);
    this.onIsolinesMaxChange = this.onIsolinesMaxChange.bind(this);
    this.onIsolinesBreakNumberChange =
      this.onIsolinesBreakNumberChange.bind(this);
    this.onIsolinesBreakIntervalChange =
      this.onIsolinesBreakIntervalChange.bind(this);
  }

  async componentDidUpdate(prevProps) {
    if (
      this.props.isolinesCaseName !== prevProps.isolinesCaseName &&
      this.props.isolinesCaseName &&
      prevProps.isolinesCaseName
    ) {
      const isolinesCase = this.props.caseDetailsDto.find((x) => {
        return x.id === this.props.isolinesCaseName;
      });
      const resultsJsonUrl = isolinesCase.postProcessingJobs.find((x) => {
        return x.reportJsonUrl;
      }).reportJsonUrl;
      const resultsJson = await downloadBlobAsync(resultsJsonUrl);
      this.props.loadIsolinesSelectedCaseData(resultsJson.data);
    }
  }

  onCaseChange(e) {}

  onPageChange(e) {
    this.props.changeIsolinesPage({
      isolinesPage: e.target.value,
      isolinesPageIndex: e.target.selectedIndex,
    });
  }

  onLayerChange(e) {
    this.props.changeIsolinesLayer({
      isolinesLayerName: e.target.value,
      isolinesLayerIndex: e.target.selectedIndex,
    });
  }

  onIsolinesPresetChange(e) {
    const isolinesPreset = e.target.value;
    if (isolinesPreset === "Solingen GAP - Height Lines") {
      this.props.changeIsolinesMin(50);
      this.props.changeIsolinesMax(300);
      this.props.changeIsolinesBreakInterval(10);
    }

    this.props.changeIsolinesPreset(isolinesPreset);
  }

  onIsolinesMinChange(e) {
    this.props.changeIsolinesMin(e.target.value);
  }

  onIsolinesMaxChange(e) {
    this.props.changeIsolinesMax(e.target.value);
  }

  onIsolinesBreakNumberChange(e) {
    this.props.changeIsolinesBreakNumber(e.target.value);
  }

  onIsolinesBreakIntervalChange(e) {
    this.props.changeIsolinesBreakInterval(e.target.value);
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <h5 style={{ marginTop: "0px" }} className="raster-settings-header">
          {`${t("LayerSelection")}`}
        </h5>
        <p className="difference-header" style={{ marginBottom: "10px" }}>{`${t(
          "Isolines are created from existing layer"
        )}`}</p>

        <ResultsSelect
          label={t("Case")}
          value={this.props.currentCase.name}
          options={[this.props.currentCase.name]}
          //onChange={this.onCaseChange}
        />

        <ResultsSelect
          label={t("Page")}
          value={this.props.isolinesPage}
          options={this.props.isolinesResultsJsonOrigin.pages.map((x) => {
            return {
              label: t(x.name),
              value: x.value,

              disabled:
                x.lyrs.length === 0 ||
                !x.lyrs.some((y) => {
                  return y.type !== "wind_dir" &&
                    y.type !== "wind_stream" &&
                    y.type !== "isolines" &&
                    y.geo_4326
                    ? true
                    : false;
                }),
            };
          })}
          onChange={this.onPageChange}
          optionsObject
        />
        <ResultsSelect
          label={t("Layer")}
          value={this.props.isolinesLayer}
          options={this.props.isolinesResultsJsonOrigin.pages[
            this.props.isolinesPageIndex
          ].lyrs.map((x) => {
            return {
              label: t(x.name),
              value: x.name,
              disabled:
                x.type !== "wind_dir" &&
                x.type !== "wind_stream" &&
                x.type !== "isolines" &&
                x.geo_4326
                  ? false
                  : true,
            };
          })}
          onChange={this.onLayerChange}
          optionsObject
        />
        <h5
          className="raster-settings-header"
          style={{ marginBottom: "16px", marginTop: "14px" }}
        >{`${t("Statistics")}`}</h5>

        <ResultsLayerInfo
          label={t("Minimum")}
          value={this.props.isolinesSelectedJsonOrigin?.stat_min}
          style={{ borderRadius: "2px 2px 0px 0px" }}
          visSettings
        />
        <ResultsLayerInfo
          label={t("25%Quantile")}
          value={this.props.isolinesSelectedJsonOrigin?.stat_q25}
          visSettings
        />
        <ResultsLayerInfo
          label={t("Median")}
          value={this.props.isolinesSelectedJsonOrigin?.stat_median}
          visSettings
        />
        <ResultsLayerInfo
          label={t("Mean")}
          value={this.props.isolinesSelectedJsonOrigin?.stat_mean}
          visSettings
        />
        <ResultsLayerInfo
          label={t("75%Quantile")}
          value={this.props.isolinesSelectedJsonOrigin?.stat_q75}
          visSettings
        />
        <ResultsLayerInfo
          label={t("Maximum")}
          value={this.props.isolinesSelectedJsonOrigin?.stat_max}
          style={{ borderRadius: "0px 0px 2px 2px" }}
          visSettings
        />

        <h5
          className="raster-settings-header"
          style={{ marginBottom: "16px", marginTop: "14px" }}
        >{`${t("IsolineSettings")}`}</h5>
        <ResultsSelect
          label={t("Preset")}
          value={this.props.isolinesPreset}
          options={isolinesPreset.map((x) => {
            return { label: x, value: x };
          })}
          onChange={this.onIsolinesPresetChange}
          optionsObject
        />
        {this.props.isolinesPreset !== "auto" && (
          <>
            <NumericResultsInput
              name={"min"}
              label={t("Minimum")}
              value={this.props.isolinesMin}
              onChange={this.onIsolinesMinChange}
              onBlur={(e) => {
                if (e.target.value === "" || e.target.value === "-") {
                  this.props.changeIsolinesMin(
                    this.props.isolinesSelectedJsonOrigin?.stat_min
                  );
                }
              }}
              disabled={
                this.props.isolinesPreset === "Solingen GAP - Height Lines"
              }
            />
            <NumericResultsInput
              label={t("Maximum")}
              value={this.props.isolinesMax}
              onChange={this.onIsolinesMaxChange}
              onBlur={(e) => {
                if (e.target.value === "" || e.target.value === "-") {
                  this.props.changeIsolinesMax(
                    this.props.isolinesSelectedJsonOrigin?.stat_max
                  );
                }
              }}
              maxLength={40}
              disabled={
                this.props.isolinesPreset === "Solingen GAP - Height Lines"
              }
            />
            {this.props.isolinesPreset === "User-defined (by Break Number)" && (
              <NumericResultsInput
                label={t("Break number")}
                value={this.props.isolinesBreakNumber}
                onChange={this.onIsolinesBreakNumberChange}
                maxLength={40}
                onBlur={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "-" ||
                    e.target.value <= 0
                  ) {
                    this.props.changeIsolinesBreakNumber(8);
                  }
                }}
              />
            )}
            {(this.props.isolinesPreset ===
              "User-defined (by Break Interval)" ||
              this.props.isolinesPreset === "Solingen GAP - Height Lines") && (
              <NumericResultsInput
                label={t("Break interval")}
                value={this.props.isolinesBreakInterval}
                onChange={this.onIsolinesBreakIntervalChange}
                maxLength={40}
                onBlur={(e) => {
                  if (
                    e.target.value === "" ||
                    e.target.value === "-" ||
                    e.target.value <= 0
                  ) {
                    this.props.changeIsolinesBreakInterval(8);
                  }
                }}
                disabled={
                  this.props.isolinesPreset === "Solingen GAP - Height Lines"
                }
              />
            )}
          </>
        )}
        {this.props.isolinesInputError && (
          <div
            style={{
              display: "flex",
              height: "fit-content",
              alignItems: "center",
              marginTop: "12px",
              justifyContent: "center",
            }}
          >
            <div>
              <XCircle
                color={"#a81d1dcf"}
                size={"14px"}
                strokeWidth={"1.8px"}
              />
            </div>
            <div
              style={{
                fontSize: "12px",
                color: "#a81d1dcf",
                paddingLeft: "6px",
              }}
            >
              {this.props.isolinesInputError}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentCase: state.projects.currentCase,
    isolinesCaseName: state.results.isolinesCaseName,
    isolinesCaseId: state.results.isolinesCaseId,
    isolinesPage: state.results.isolinesPage,
    isolinesPageIndex: state.results.isolinesPageIndex,
    isolinesLayer: state.results.isolinesLayer,
    isolinesLayerIndex: state.results.isolinesLayerIndex,
    diffPageOptions: state.results.diffPageOptions,
    isolinesResultsJsonOrigin: state.results.isolinesResultsJsonOrigin,
    isolinesSelectedJsonOrigin: state.results.isolinesSelectedJsonOrigin,
    isolinesPreset: state.results.isolinesPreset,
    isolinesMin: state.results.isolinesMin,
    isolinesMax: state.results.isolinesMax,
    isolinesBreakInterval: state.results.isolinesBreakInterval,
    isolinesBreakNumber: state.results.isolinesBreakNumber,
    isolinesInputError: state.results.isolinesInputError,
    caseDetailsDto: state.projects.loadedProject?.caseDetailsDto,
    postProcessingJobs: state.projects.currentCase?.postProcessingJobs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeNewLayerIsolinesCase: (payload) =>
      dispatch(changeNewLayerIsolinesCase(payload)),
    changeIsolinesPage: (payload) => dispatch(changeIsolinesPage(payload)),
    changeIsolinesLayer: (payload) => dispatch(changeIsolinesLayer(payload)),
    changeIsolinesPreset: (payload) => dispatch(changeIsolinesPreset(payload)),
    changeIsolinesMin: (payload) => dispatch(changeIsolinesMin(payload)),
    changeIsolinesMax: (payload) => dispatch(changeIsolinesMax(payload)),
    changeIsolinesBreakNumber: (payload) =>
      dispatch(changeIsolinesBreakNumber(payload)),
    changeIsolinesBreakInterval: (payload) =>
      dispatch(changeIsolinesBreakInterval(payload)),
    loadIsolinesSelectedCaseData: (payload) =>
      dispatch(loadIsolinesSelectedCaseData(payload)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Isolines)
);
